var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.27418 0.274649C-0.0913935 0.639596 -0.0913935 1.22798 0.27418 1.59293L6.47402 7.78215C6.76499 8.07262 7.23501 8.07262 7.52598 7.78215L13.7258 1.59293C14.0914 1.22798 14.0914 0.639597 13.7258 0.274649C13.3602 -0.0902988 12.7708 -0.0902989 12.4053 0.274649L6.99627 5.66694L1.58726 0.267201C1.22915 -0.0902993 0.632294 -0.0902994 0.27418 0.274649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.21a1d589e0ce540bdc1d44905aad1d8f.svg";
export { ForwardRef as ReactComponent };